module.exports = __webpack_public_path__ + "static/media/Torree.66a91fb1.jpg";